module.exports = "<simple-notifications></simple-notifications>\n<ng4-loading-spinner> </ng4-loading-spinner>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main